import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component SunIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <SunIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <SunIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const SunIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={22}
      viewBox="0 0 22 22"
      data-testid="SunIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M11 0a1 1 0 0 1 1 1v1.818a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1" />
      <path
        fillRule="evenodd"
        d="M5 11a6 6 0 1 1 12 0 6 6 0 0 1-12 0m6-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
        clipRule="evenodd"
      />
      <path d="M12 19.182a1 1 0 1 0-2 0V21a1 1 0 1 0 2 0zM3.22 3.22a1 1 0 0 1 1.414 0l1.291 1.291a1 1 0 1 1-1.414 1.414l-1.29-1.29a1 1 0 0 1 0-1.415M17.489 16.075a1 1 0 0 0-1.414 1.414l1.29 1.29a1 1 0 0 0 1.415-1.413zM0 11a1 1 0 0 1 1-1h1.818a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1M19.182 10a1 1 0 1 0 0 2H21a1 1 0 1 0 0-2zM5.925 16.075a1 1 0 0 1 0 1.414l-1.29 1.29a1 1 0 0 1-1.415-1.413l1.291-1.291a1 1 0 0 1 1.414 0M18.78 4.634a1 1 0 0 0-1.414-1.414l-1.291 1.291a1 1 0 0 0 1.414 1.414z" />
    </svg>
  )
);
SunIcon.displayName = "SunIcon";
export default SunIcon;
